import React, { useEffect, useState } from "react";
import { getRecentPatients, RecentPatient } from "../../utils/recentPatients";

interface RecentPatientsListProps {
  onSelectPatient: (id: string) => void;
}

const RecentPatientsList: React.FC<RecentPatientsListProps> = ({
  onSelectPatient,
}) => {
  const [patients, setPatients] = useState<RecentPatient[]>([]);

  const loadPatients = () => {
    setPatients(getRecentPatients());
  };

  useEffect(() => {
    // Load initially
    /* eslint-disable-next-line react-hooks/set-state-in-effect */
    loadPatients();

    // Listen for storage events (updates from other tabs or from our own record call)
    window.addEventListener("storage", loadPatients);

    return () => {
      window.removeEventListener("storage", loadPatients);
    };
  }, []);

  if (patients.length === 0) {
    return (
      <div className="bg-gray-50 border border-gray-200 border-dashed rounded-md p-6 text-center text-sm text-gray-500">
        No recent patients yet. Look one up to get started.
      </div>
    );
  }

  return (
    <ul className="divide-y divide-gray-200">
      {patients.map((patient) => {
        const label = patient.name?.trim() ? patient.name : patient.patientId;
        return (
          <li key={patient.patientId}>
            <button
              type="button"
              onClick={() => onSelectPatient(patient.patientId)}
              className="w-full text-left flex items-center gap-4 py-4 px-3 hover:bg-gray-50 cursor-pointer transition-colors focus:outline-none focus:bg-gray-50 rounded-md"
            >
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center font-medium text-sm">
                {label.charAt(0).toUpperCase()}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-900 truncate">
                  {label}
                </p>
                <p className="text-xs text-gray-500 truncate">
                  Athena ID: {patient.patientId}
                </p>
              </div>
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default RecentPatientsList;
